import React from "react";
// Importing css file
import "./NotFound.css";
const NotFound = () => {
  return (
    <div className="not-found">
      <h1>
        Oops!!! <br />
        <span> Sorry, the page you were trying to load doesn't exist.</span>
      </h1>
    </div>
  );
};

export default NotFound;
